import { PlacemarkPageDescription } from './page-descriptions';
import { PwaUrl } from './pwa-url';
import { PwaUrlBuilder } from './pwa-url-builder';
import { Url } from './url';

export class WwwUrlBuilder extends PwaUrlBuilder {
  static override fromLocale(locale: string): WwwUrlBuilder {
    switch (locale) {
      case 'de-AT':
        return new WwwUrlBuilder('de-AT');
      case 'de-CH':
        return new WwwUrlBuilder('de-CH');
    }
    return new WwwUrlBuilder('de-DE');
  }

  protected override buildPlacemarkBased(input: PlacemarkPageDescription): Url {
    const urlPath = input.urlPath;

    if (urlPath.includes('gid=')) {
      return new PwaUrl({
        segments: [urlPath],
      });
    }

    return new PwaUrl({
      segments: [...this.basePath(input.recipe).pathSegments, urlPath],
    });
  }
}
